import React from 'react'

import { LeavePreventionContext } from '../LeavePreventionContext'
import { useLeavePageConfirm } from '@/hooks/useLeavePageConfirm'

type LeavePreventionProviderProps = {
  children: React.ReactNode
}

export function LeavePreventionProvider({
  children,
}: LeavePreventionProviderProps): JSX.Element {
  const [
    PreventionComponent,
    showLeavePreventionModal,
    hideLeavePreventionModal,
  ] = useLeavePageConfirm()

  return (
    <LeavePreventionContext.Provider
      value={{ hideLeavePreventionModal, showLeavePreventionModal }}
    >
      <PreventionComponent />
      {children}
    </LeavePreventionContext.Provider>
  )
}
